import { Component, OnInit, Inject, ViewChild, Input, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import * as _ from 'lodash-es';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { getPageSize } from 'src/app/shared/utils/calsoft-validators';
import { Constant } from 'src/app/constant/constant';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProductService } from 'src/app/services/product.service';
import { ListColumn } from '../list/list-column.model';

@Component({
  selector: 'calsoft-lead-owner-search',
  templateUrl: './lead-owner-search.component.html',
  styleUrls: ['./lead-owner-search.component.scss']
})
export class LeadOwnerSearchComponent implements OnInit, OnDestroy {

  sanitizedUrl: string = '';


  url = '';


  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  paginationDetail = new BehaviorSubject(
    {
      length: 10,
      pageIndex: 0,
      pageSize: 10
    });
  data: any;
  index: any;
  group: UntypedFormGroup;
  elements: any;
  filterActive: boolean = false;
  selectUpload: boolean = false;
  resourcePrivilege: any;
  urlPage: any;
  urlSize: any;
  urlSort: string;
  groupIndex: any;
  firstFormGroup: UntypedFormGroup;
  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;
  redirected: boolean = false;
  leadCalls: any = [];
  spinner: boolean;
  pageList: any;
  pageSizeValue: any = [];
  search: any;
  searchTerm: any = 'All';
  assignedAttributeId: any = [0];
  removedFilterAttributeIdList: any = [];
  sortParam: any = 'updatedDate' + "," + Constant.Dsc;
  sortParamInit: any = 'updatedDate' + "," + Constant.Dsc;

  sampletFilterAttributeIdList: any = [];
  oldList: any = [];
  newlyAddedList: any = [];
  event: string = 'none';
  entityTypeId: any;
  serviceUrl: string;
  productList: any;
  LeadNameList: any;
  LeadEmailList: any;
  LeadPhoneNumberList: any;

  constructor(
    private dialogRef: MatDialogRef<LeadOwnerSearchComponent>,
    @Inject(MAT_DIALOG_DATA) data,
    public formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private productService: ProductService, private router: Router
  ) {
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });
  }


  ngOnInit() {
    this.productList = [];
    console.log(this.productList);

    //this.getLeadOwnerSearch();
  }


  close() {
    this.dialog.closeAll();
  }

  getLeadOwnerSearch() {
    // this.filterActive = false;
    // this.spinner = true;
    // this.productService.getLead(this.page, this.size, this.sortParam != undefined ? this.sortParam : this.sortParamInit).subscribe(
    //   res => {
    //     this.spinner = false;
    //     this.productList = new MatTableDataSource();
    //     this.elements = res['numberOfElements'];
    //     this.productList = res['content'];
    //     this.productList.sort = this.sort;
    //     this.productList.paginator = this.paginator;
    //     this.pageList = res['totalElements'];
    //     this.LeadNameList = this.productList.name;
    //     this.LeadEmailList = this.productList.ownerEmail;
    //     this.LeadPhoneNumberList = this.productList.phoneNumber;
    //     this.pageSizeValue = getPageSize(this.pageList);
    //   },
    //   error => {
    //   }
    // )
    this.productList = [];
    this.spinner = false;
  }
  DetectingRequestType() {
    if (!this.filterActive) {
      this.getLeadOwnerSearch();
    }
    else {
      this.filterOption(this.search);
    }
  }


  getUpdate(event) {
    this.paginationDetail.next(event);
    this.page = event.pageIndex;
    this.size = event.pageSize;
    this.DetectingRequestType();
  }


  sortData(event) {
    if (event.active != 'actions') {
      this.page = Constant.PAGE;
      this.size = Constant.SIZE;
      this.sortParam = event.active;
      if (event.direction == 'asc') {
        this.sortParam = this.sortParam + "," + Constant.Asc;
      } else if (event.direction == 'desc') {
        this.sortParam = this.sortParam + "," + Constant.Dsc;
      }
      this.DetectingRequestType();
    }
  }

  onFilterChangeColumn(i) {
    if (i == undefined) {
      this.filterActive = false
      this.getLeadOwnerSearch();
    } else {
      i = i.replace(/'/g, '');
      this.page = Constant.PAGE;
      this.size = Constant.SIZE;
      this.filterOption(i)
    }
  }

  onFilterChange(value) {
    if (value == '') {
      this.getLeadOwnerSearch();
      this.search = '';
    }
    else {
      this.page = Constant.PAGE;
      this.size = Constant.SIZE;



      let searchTerm = "phoneNumber:" + '*' + value.trim() + '*'
        + "' OR email:" + '*' + value.trim() + '*' + "' "
      this.filterOption(searchTerm)


    }
  }


  filterOption(event) {
    this.filterActive = true;
    this.search = event;
    this.spinner = true;
    this.productService.getLeadOwnerSearchNew(this.search, this.page, this.size, this.sortParam).subscribe(
      res => {
        this.spinner = false;
        this.productList = res['content'];
        this.elements = res['numberOfElements'];
        this.pageList = res['totalElements'];
        this.pageSizeValue = getPageSize(this.pageList);
      },
      error => {
        this.spinner = false;
      })
  }





  @Input()
  columns: ListColumn[] = [
    // { name: 'Name', property: 'name', visible: true, isModelProperty: true },
    // { name: 'Phone No', property: 'phoneNumber', visible: true, isModelProperty: true },
    // { name: 'Product', property: 'product', visible: true, isModelProperty: true },
    // { name: 'Status Name', property: 'statusName', visible: true, isModelProperty: true },
    // { name: 'Owner', property: 'ownerEmail', visible: true, isModelProperty: false },
  ] as ListColumn[];

  filterSelectObj = [
    {
      name: 'Name',
      property: 'name',
      type: 'text',
      position: 'firstValue',
      options: []
    },
    {
      name: 'Phone No',
      property: 'phoneNumber',
      type: 'text',
      position: 'secondValue',
      options: []
    },

    {
      name: 'Product',
      property: 'product',
      type: 'text',
      position: 'thirdValue',
      options: []
    },

    {
      name: 'Status Name',
      property: 'statusName',
      type: 'multiSelect',
      position: 'fourthValue',
      options: [],
      display: true
    },
    {
      name: 'Owner',
      property: 'ownerEmail',
      type: 'multiSelect',
      position: 'fifthValue',
      options: [],
      display: true
    },

  ]



  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  protected _onDestroy = new Subject<void>();

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
